import { Avatar, Link } from '@mui/material';

import type { AdModel, UserModel } from '@/types';
import { stringAvatar } from '@/utils';

import styles from './AdsListItem.module.scss';

interface AdsListItemCreatorInfoProps {
  agencyName?: string;
  creator: AdModel['propertyAdCreator'];
  creatorEmployer: AdModel['propertyAdCreatorEmployer'];
  creatorEmployerHref: string;
  creatorHref: string;
  isTariffFree: boolean;
  onLockedCreatorClick: () => void;
  user?: UserModel;
  userName: string;
}

export const AdsListItemCreatorInfo = ({
  agencyName,
  creator,
  creatorEmployer,
  creatorEmployerHref,
  creatorHref,
  isTariffFree,
  onLockedCreatorClick,
  user,
  userName,
}: AdsListItemCreatorInfoProps) => (
  <div className={`${styles.itemLinks} ${isTariffFree ? styles.blurText : styles.text}`}>
    {user ? (
      <Link title={userName}>
        <Avatar
          src={user?.media?.[0]?.fileUrl || undefined}
          alt={userName}
          {...stringAvatar(userName)}
        />
        <span>{userName}</span>
      </Link>
    ) : (
      <Link
        href={isTariffFree ? undefined : creatorHref}
        title={userName}
        onClick={() => isTariffFree && onLockedCreatorClick()}
      >
        <Avatar src={creator?.avatar || undefined} alt={userName} {...stringAvatar(userName)} />
        <span>{userName}</span>
      </Link>
    )}
    {(creatorEmployer || isTariffFree) && (
      <Link
        href={isTariffFree ? undefined : creatorEmployerHref}
        title={agencyName}
        onClick={() => isTariffFree && onLockedCreatorClick()}
      >
        <Avatar
          src={creatorEmployer?.avatar || undefined}
          alt={agencyName}
          {...stringAvatar(agencyName)}
        />
        <span>{agencyName}</span>
      </Link>
    )}
  </div>
);
